<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8ycqyi/tc-custom/9780547941875.jpg?1734331435975" alt="This image is the cover for the book Turquoise"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Turquoise
      </h1>
      <p class="bookDescription body article font2">
        <b>A novel of a girl’s journey from an orphaned childhood in New Mexico to an opulent life in Gilded Age New York, by the author of <i>Avalon</i>.</b><br/>  <br/> In 1850, as her mother lay dying and a priest stood by, Santa Fe Cameron was named by her Scottish father after the town in which she had just been born. At seven years old, she would also lose her father.<br/>  <br/> Shortly thereafter, a Navajo shaman recognized psychic power in the orphan girl, and gave her a turquoise pendant as a keepsake. This turquoise, the Indian symbol of the spirit, will dominate her life—even after she leaves the simple beauty of her native New Mexico to search for happiness in the glamorous New York of the 1870s.<br/>  <br/> For “Fey,” life is made up of violent contrasts: the rough wagon that brings her East and the scented carriages waiting before her own Fifth Avenue mansion; the glittering world of the Astors and a dreary cell in the Tombs. Filled with color, excitement, and rich period detail, and starring an unforgettable heroine, this is a stirring historical saga from the author of <i>Katherine</i>, <i>Foxfire</i>, and many other novels.<br/>  <br/> “Seton, at her best, has a gaudy vitality all her own, and a sure sense of theatre. This reader for one enjoyed <i>The Turquoise</i> enormously.” —<i>The New York Times</i><br/>  <br/> “With accurate historical background, Anya Seton has constructed a touchingly tragic story of a girl who tried so hard to find happiness that she lost everything in her search. The life of Santa Fe Cameron lingers long in memory.” —<i>Springfield Republican</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anya Seton
      </h2>
      
      <p class="authorDescription body article">Anya Seton (1904&ndash;1990) was the author of many bestselling historical novels, including <I>Katherine, Avalon, Dragonwyck, Devil Water,</I> and <I>Foxfire</I>. She lived in Greenwich, Connecticut.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?34cd76a6